module.exports = __webpack_public_path__ + "assets/1c3da6e9c653788fa7a4b4b19e522df1.mp3";